import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-5cb40720"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "general" }
const _hoisted_5 = {
  key: 0,
  class: "card bg-secondary",
  style: {"max-width":"30rem"}
}
const _hoisted_6 = {
  key: 1,
  class: "card bg-secondary",
  style: {"max-width":"30rem"}
}
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bold"} }, "Facturas por Período", -1))
const _hoisted_9 = { id: "customers" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Período"),
  /*#__PURE__*/_createElementVNode("th", null, "Cant."),
  /*#__PURE__*/_createElementVNode("th", null, "Total")
], -1))
const _hoisted_11 = { class: "ta-r" }
const _hoisted_12 = { class: "ta-r" }
const _hoisted_13 = { style: {"font-weight":"bold"} }
const _hoisted_14 = { class: "ta-r" }
const _hoisted_15 = { class: "ta-r" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(_toDisplayString(this.factsGpedByCli) + " ", 1),
    _createElementVNode("div", null, [
      _createVNode(_component_Navbar),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          ($data.cargando)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        (
          this.$store.state.user.type == 'Power User' ||
            this.$store.state.user.type == 'Administrador'
        )
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, null, 512)), [
              [_vShow, !$data.cargando]
            ])
          : _createCommentVNode("", true),
        (
          this.$store.state.user.type == 'Power User' ||
            this.$store.state.user.type == 'Administrador'
        )
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("table", _hoisted_9, [
                  _hoisted_10,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.factsGpedByCli, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_11, _toDisplayString($options.formatNumber(item.count)) + " (" + _toDisplayString($options.formatNumber((item.count / this.totales.facturas2) * 100)) + "%) ", 1),
                      _createElementVNode("td", _hoisted_12, _toDisplayString($options.formatNumber(item.cobertura, true)) + " (" + _toDisplayString($options.formatNumber(
                    (item.cobertura / this.totales.cobertura2) * 100
                  )) + "%) ", 1)
                    ]))
                  }), 128)),
                  _createElementVNode("tr", _hoisted_13, [
                    _createElementVNode("td", null, "Total: " + _toDisplayString(this.totales.cantClientes), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString($options.formatNumber(this.totales.facturas)), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString($options.formatNumber(this.totales.cobertura, true)), 1)
                  ])
                ])
              ])
            ], 512)), [
              [_vShow, !$data.cargando]
            ])
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, !$data.cargando]
      ])
    ])
  ], 64))
}